import React from "react";
import svgIcons from "../assets/svg/svgIcons";

type TSearchBoxProps = {
  controlledValue?: string;
  disabled?: boolean;
  initialValue?: string;
  inputClassName?: string;
  loading?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  placeholder: string;
  wrapperClassName?: string;
  searchIconClassName?:string;
};

const AppSearchBox= React.forwardRef<HTMLInputElement, TSearchBoxProps>(
  (
    {
      controlledValue,
      disabled = false,
      initialValue = "",
      inputClassName = "w-full rounded-md border-gray-200 py-2.5 ps-10 shadow-sm sm:text-sm",
      loading = false,
      onChange,
      onClear,
      placeholder,
      wrapperClassName = "",
      searchIconClassName=""
    },
  ref
) => {
  const [searchText, setSearchText] = React.useState<string>(initialValue);
  const inputRef = React.useRef<HTMLInputElement>(null);
  return (
    <div
      className={`relative ${wrapperClassName}`}
      onClick={(e) => e.stopPropagation()}
    >
      {loading && (
        <span className="absolute inset-y-0 end-0 grid w-10 place-content-center">
          <img
            src={svgIcons.LoadingAnimation}
            alt={"Loading"}
            className="size-6"
          />
        </span>
      )}
      <input
        ref={ref}
        type="text"
        placeholder={placeholder}
        value={controlledValue ?? searchText ?? ""}
        onChange={(e) => {
          setSearchText(e.target.value);
          onChange?.(e);
        }}
        className={`${inputClassName}${onClear ? " pe-8" : ""}${disabled ? " opacity-60" : ""}`}
        disabled={disabled}
      />

      <span
        className={`absolute inset-y-0 start-0 grid w-10 place-content-center${searchIconClassName}${disabled ? " opacity-25" : ""}`}
      >
        <span className="text-gray-600 hover:text-gray-700">
          <span className="sr-only">Search</span>

          <img src={svgIcons.SearchIcon} alt={"Search"} className="size-4" />
        </span>
      </span>
      {!!onClear && !!(controlledValue || searchText) && !loading && (
        <button
          type="button"
          className="absolute inset-y-0 end-0 grid w-10 place-content-center"
        >
          <img
            src={svgIcons.CloseIcon}
            alt={"Clear"}
            className="size-5 cursor-pointer opacity-80 hover:opacity-40"
            onClick={() => {
              setSearchText("");
              onClear?.();
            }}
          />
        </button>
      )}
    </div>
  );
});
export default AppSearchBox;
